<template>
    <div class="disclosure-editor textarea-outline-x">
        <textarea
            ref="textarea"
            v-model="input"
            class="input-control textarea-outline resize-none outline-none"
            :placeholder="placeholder">
        </textarea>
        <label class="input-count flex h-7 items-center">
            <span class="warning-text hidden rounded bg-yellow-40 px-2 py-0.5"
                  v-if="modelValue.length"
            >
                {{ $t('textWarning',{number: warningNumber}) }}
            </span>
            <span class="ml-auto">
                {{modelValue.length}}/2000
            </span>
        </label>
    </div>
</template>

<script lang="ts" setup>
import { watch, onMounted, ref } from 'vue'
const input = ref('')
const props = defineProps({
    modelValue: {
        type: String,
        default: () => '',
    },
    placeholder: {
        type: String,
        default: () => '',
    },
    warningNumber: {
        type: Number,
        default: () => 0,
    },
})

const emit = defineEmits(['update:modelValue'])
watch(() => props.modelValue, (v) => {
    input.value = v;
})

watch(input, (v) => {
    emit('update:modelValue', v);
})

onMounted(() => {
    input.value = props.modelValue;
})

</script>
